import styled from 'styled-components'
import { tableContainer } from '../styled'
import { useTranslation } from 'react-i18next'
import { Title } from 'views/pages/Teams/TeamsTableCard/styled'
import { SellerTable } from 'views/pages/Teams/SellerTableCard/SellerTable'
import { useSingleEntity } from 'modules/domain/common/hooks'
import { TeamMargin } from 'modules/domain/teams/types'
import { endpoints } from 'modules/endpoints'

const Container = styled.div`
  ${tableContainer};
  width: 448px;
`

export const SellerTableCard = () => {
  const { t } = useTranslation('teams')

  const [progress, teamsData = []] = useSingleEntity<TeamMargin[]>(endpoints.teamsMarginForCurrentMonth('customer'))

  return (
    <div>
      <Container>
        <Title>{t('selling')}</Title>
        <SellerTable teamsData={teamsData} progress={progress} />
      </Container>
    </div>
  )
}
